// extracted by mini-css-extract-plugin
module.exports = {"recentlySearched":"RecentlySearched_recentlySearched__xhBQU","recentlySearchedProducts":"RecentlySearched_recentlySearchedProducts__27iSN"};